import React, 
      { useState , 
        useEffect,
        useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Radio             from '@mui/material/Radio'
import RadioGroup        from '@mui/material/RadioGroup'
import FormControlLabel  from '@mui/material/FormControlLabel'
import ArrowForwardIcon  from '@mui/icons-material/ArrowForward'
import store             from '../../store'
import '../../App.css'
import '../../style.css';


function CalculationModeSelect({ calcType, setCalcType }) {
  // ラジオボタンの選択が変更された時の処理
  const handleRadioChange = (event) => {
    const value = event.target.value;
    setCalcType(value);                 // 親の state を更新
    store.getState().CalcSelect = value; // 互換のため store にも反映
    console.log('選択中の計算式:', value);
  };

  useEffect(() => {
    console.log('選択中の計算式=>', calcType);
  }, [calcType]);


  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* 画面 */}
        <Paper sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
        }}>
          <Grid container spacing={0}>
              {/* タイトル表示 */}
              <Grid item xs={12} align="center">
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "24px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    }}>けいさんのしゅるい</Typography>
              </Grid>

              {/* 選択欄表示 */}
              <Grid item xs={12} align="center">
                <Box
                  sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // フォント
                    color        : '#000000'       , // フォントの色を黒に設定
                    border       : '3px solid #696969', // 枠線の太さと色を設定
                    borderRadius : '5px'           , // 角丸の半径を設定
                    padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
                    top          : '75px'         , // 縦位置を指定
                    left         : '135px'         , // 横位置を指定
                    position     : 'absolute'      , // 絶対位置指定
                    }}>
                  <RadioGroup 
                    name="radio-buttons-group"
                    value={calcType}
                    onChange={handleRadioChange}>
                    <FormControlLabel 
                      value="tashi" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="たしざん" 
                      sx={{ marginBottom: '-3px' }} // ラベルの下マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="hiki" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="ひきざん" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="kake" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="かけざん" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                  </RadioGroup>
                </Box>
              </Grid>

              {/* メッセージ欄表示 */}
              <Grid 
                item xs={12} 
                align="center"
                sx={{
                  border       : '3px solid #696969', // 枠線の太さと色を設定
                  borderRadius : '5px'           , // 角丸の半径を設定
                  padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
                  top          : '200px'         , // 縦位置を指定
                  left         : '5px'           , // 横位置を指定
                  position     : 'absolute'      , // 絶対位置指定
                  width        : '96%'           , // 外枠の幅を指定
                  height       : '23%'           , // 外枠の高さを指定
                  }}>
                  <Typography
                    sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // フォント
                      fontSize     : "12px"          , 
                      color        : '#000000'       , // フォントの色を黒に設定
                      }}
                    tabIndex={0} // キーボードフォーカス可能にする
                    >けいさんのしゅるいをえらんでね<br />
                    1.↑↓でえらぶ<br />
                    2.Aボタンでけってい</Typography>
              </Grid>
          </Grid>
        </Paper>
      <Grid container spacing={2}>
          <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  );
}

export default CalculationModeSelect
